import router from '@/router/index';
import { requestRoot } from '@/axios';

const state = {
  games: [],
};

const getters = {
  getGamesInfo: state => state.games.sort((a, b) => a.id - b.id),
  getGameById: state => (id) => {
    const gameId = id || router.currentRoute.params.id;
    return state.games.find(game => game.id === gameId);
  },
};
const actions = {
  saveGameLogs({ rootGetters }, data) { // TODO refactor
    return new Promise((resolve, reject) => {
      const gameLogs = {};
      let unsavedLogs = JSON.parse(localStorage.getItem('unsaved_logs')) || [];
      let myUnsavedLogs = [];
      const currentAssignment = rootGetters['gameConfig/getCurrentAssignment'];
      const isALI = localStorage.getItem('ALI');
      gameLogs.game_id = +router.currentRoute.params.id;
      gameLogs.child_id = rootGetters['children/activeChildProfile'].id;
      gameLogs.parent_id = rootGetters['parent/parentAccount']?.id || null;
      if (isALI) {
        gameLogs.ali = true;
      }

      if (currentAssignment) {
        gameLogs.assignment_id = currentAssignment.playlists[0]._id;
      }
      gameLogs.logs = data;

      if (unsavedLogs.length) {
        myUnsavedLogs = unsavedLogs.filter(e => e.child_id === gameLogs.child_id);
      }

      myUnsavedLogs.push(gameLogs);
      console.log(myUnsavedLogs); // checking if is working correct
      requestRoot.post('/game/logs/add', myUnsavedLogs)
        .then(() => {
          unsavedLogs = unsavedLogs.filter(e => e.child_id !== gameLogs.child_id);
          localStorage.setItem('unsaved_logs', JSON.stringify(unsavedLogs));
          resolve();
        })
        .catch((err) => {
          unsavedLogs.push(gameLogs);
          localStorage.setItem('unsaved_logs', JSON.stringify(unsavedLogs));
          console.error(err);
          reject();
        });
    });
  },
  addGamesInfo({ commit }, games) {
    commit('addGamesInfo', games);
  },
};
const mutations = {
  addGamesInfo(state, games) {
    state.games = games;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
